import { render, staticRenderFns } from "./Sopyo.vue?vue&type=template&id=2703aadc&scoped=true"
import script from "./Sopyo.vue?vue&type=script&lang=js"
export * from "./Sopyo.vue?vue&type=script&lang=js"
import style0 from "./Sopyo.vue?vue&type=style&index=0&id=2703aadc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2703aadc",
  null
  
)

export default component.exports